let baseUrl = "";
let baseUrlOrigin = "";
export const WebSocketURL = "wss://cnaf.digimasia.com/ws";

const environment = import.meta.env.VITE_ENVIRONMENT;

if (environment === "production") {
  baseUrl =
    "https://cnaf.digimasia.com/api/public/index.php";
    baseUrlOrigin = "https://cnaf.digimasia.com"
} else if (environment === "staging") {
  baseUrl =
    "https://cnaf-staging.digimasia.com/api/public/index.php";
    baseUrlOrigin = "https://cnaf-staging.digimasia.com"
} else {
  baseUrl =
    "https://cnaf-staging.digimasia.com/api/public/index.php";
    baseUrlOrigin = "https://cnaf-staging.digimasia.com"
}

export { baseUrlOrigin };
export default baseUrl;
